import { MultiLegTable } from "./components/MultiLegTable/MultiLegTable";
import { RfqTable } from "./components/RfqTable/RfqTable";
import { SingleLegTable } from "./components/SingleLegTable/SingleLegTable";
import { useRfqResponses } from "./hooks/useRfqResponses";

export const RfqResponses: React.FC = () => {
  const { filteredSingleResponses, filteredMultiResponses, tableData } =
    useRfqResponses();

  return (
    <RfqTable data={tableData} variant="outmost">
      {(row) =>
        row.variant === "single" ? (
          <SingleLegTable
            data={filteredSingleResponses}
            hasMultiLegs={Boolean(filteredMultiResponses.length)}
          />
        ) : (
          <MultiLegTable data={filteredMultiResponses} />
        )
      }
    </RfqTable>
  );
};
